module.exports = "<div class='hThree themeBG cancel-conf-button' (click)=\"onButtonClick()\" data-slnm-ihg='makeAnotherReservationButtonSID' [innerText]=\"messages['links.makeanotherreservation.label']\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/make-another-reservation/make-another-reservation.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/make-another-reservation/make-another-reservation.component.html
// module chunks = 0